<template>
    <div class="relative bg-white rounded-2xl p-4 mr-8 shadow-2xl mt-4 mb-24 inline-block">
        <div class="inline-block">
            <div class="text-3xl mx-3 my-1 float-left text-gray-800 font-bold">{{ title }}</div>
        </div>
        <div class="inline-flex ml-2 mb-2 float-right">
            <div class="table text-center">
                <div class="table-cell px-2 cursor-pointer" v-if="sampleReport !== 0" @click="showSampleReport = true">
                    <div class="inline-block sprite-icons-sample heartbeat"></div>
                    <div class="text-xs">Sample Report</div>
                </div>
                <div class="table-cell px-2 cursor-pointer">
                    <div class="inline-block sprite-icons-more rubberband" @click="toggleHelp()"></div>
                    <div class="text-xs">Tell me more</div>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
        <slot></slot>
        <m-dialog :show.sync="tellMeMore.visible" heading="Tell Me More" width="580px">
            <div class="ck-content" v-html="tellMeMore.body"></div>
        </m-dialog>
        <m-dialog :show.sync="showSampleReport" heading="Sample Report" width="1024px">
            <object class="w-full border-none bg-loading" style="height: 80vh"
                    :data="'/Sample Report?product=' + sampleReport" type="application/pdf">
                <div class="text-2xl text-center mt-4">Cannot render sample PDF.</div>
            </object>
        </m-dialog>
    </div>
</template>
<script>
import Ajax from "@/js/ajax";

export default {
    props: {
        title: String,
        tellMeMoreUrl: String,
        sampleReport: { // should be the productId
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            tellMeMore: {
                title: '',
                body: '',
                visible: false
            },
            showSampleReport: false
        }
    },
    methods: {
        toggleHelp() {
            Ajax.get(`/tellmemore/${this.tellMeMoreUrl}.html`).then(resp => {
                this.tellMeMore.body = resp
                this.tellMeMore.visible = true
            })
        }
    }
}
</script>
